module.exports = __webpack_public_path__ + "img/spa.db27f642.gif";